import React from 'react';
import { Tooltip } from '@mui/material';

const TooltipCellContent = ({ children, title, placement = "top" }) => {
  const needsTooltip = title && title.length > 20;

  if (!needsTooltip) {
    return <>{children}</>;
  }

  return (
    <Tooltip
      title={title}
      placement={placement}
      arrow
      PopperProps={{
        sx: {
          zIndex: 1300,
        },
      }}
      componentsProps={{
        tooltip: {
          sx: {
            bgcolor: 'background.paper',
            color: 'text.primary',
            fontSize: '0.875rem',
            maxWidth: '300px',
            wordBreak: 'break-word',
            padding: '8px',
            borderRadius: '8px',
            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
          },
        },
      }}
    >
      <span
        style={{
          display: 'inline-block',
          maxWidth: '100%',
          overflow: 'hidden',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          verticalAlign: 'middle',
        }}
      >
        {children}
      </span>
    </Tooltip>
  );
};

export default TooltipCellContent;
